import { useEffect } from "react";

export default function useParallax() {
  useEffect(() => {
    const onScroll = () => {
      const bg = document.querySelector(".hero-bg");
      if (bg) bg.style.transform = `translateY(${window.scrollY * 0.3}px)`;
    };

    window.addEventListener("scroll", onScroll);
  }, []);
}